import { Component, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { TooltipComponent } from '@shared/components/tooltip/tooltip.component';

import { SidebarItem } from '../sidebar.model';

export type { SidebarItem } from '../sidebar.model';

@Component({
  selector: 'app-sidebar-item',
  imports: [RouterLink, RouterLinkActive, TooltipComponent],
  templateUrl: './sidebar-item.component.html'
})
export class SidebarItemComponent {
  label = input.required<string>();
  item = input.required<SidebarItem>();
  collapsed = input<boolean>(false);
}
